// extracted by mini-css-extract-plugin
export default {"container":"App_container__0c5G8","flexContainer":"App_flexContainer__iMgPl"};